module.exports = __webpack_public_path__ + "img/9788946072701.b69fe17b.jpg";